// CVVC's provider roster (Provider & Location Mapping sheet). All providers are vascular/
// interventional (no podiatry service line, unlike StrideCare) - referral-eligible-provider pools
// for diagnosis-based routing (e.g. GAE, plantar fasciitis) land in the workflow-steps phase.
type CvvcProviderRosterEntry = {
  name: string;
  athenaProviderId: string;
  credential: "MD" | "PA-C";
  // Athena department ID this provider is tied to, or null for providers who float across all
  // CVVC locations.
  departmentId: string | null;
  // Athena "assignedto" staff bucket login (Index Mapping sheet), or null if not yet provided by CVVC.
  athenaStaffBucket: string | null;
};

export const CVVC_PROVIDERS = {
  ENGLISH: {
    name: "Sean J. English, MD",
    athenaProviderId: "161",
    credential: "MD",
    departmentId: "235",
    athenaStaffBucket: "senglish31 STAFF",
  },
  FORTUNA: {
    name: "Gerald R. Fortuna, MD",
    athenaProviderId: "162",
    credential: "MD",
    departmentId: "234",
    athenaStaffBucket: "jfortuna3 STAFF",
  },
  FRANZ: {
    name: "Randall W. Franz, MD",
    athenaProviderId: "163",
    credential: "MD",
    departmentId: "237",
    athenaStaffBucket: "rfranz10 STAFF",
  },
  HISLOP: {
    name: "Sean J. Hislop, MD",
    athenaProviderId: "164",
    credential: "MD",
    departmentId: "238",
    athenaStaffBucket: "shislop1 STAFF",
  },
  HOCHBERG: {
    name: "Kristian O. Hochberg, MD",
    athenaProviderId: "165",
    credential: "MD",
    departmentId: "236",
    athenaStaffBucket: "khochberg2 STAFF",
  },
  KEEFER: {
    name: "Adam J. Keefer, MD",
    athenaProviderId: "166",
    credential: "MD",
    departmentId: "239",
    athenaStaffBucket: "akeefer2 STAFF",
  },
  // Floats across all locations, unlike the other MDs above who are each tied to a home department.
  JAECKLIN: {
    name: "Frederick Jaecklin, MD",
    athenaProviderId: "183",
    credential: "MD",
    departmentId: null,
    athenaStaffBucket: "fjaecklein1 STAFF",
  },
  CHARGUALAF: {
    name: "Mark Chargualaf, PA-C",
    athenaProviderId: "185",
    credential: "PA-C",
    departmentId: null,
    athenaStaffBucket: "mchargulaaf STAFF",
  },
  // No staff bucket provided yet.
  GREENWOOD: {
    name: "Jesse (Jessica Marie) Greenwood, PA-C",
    athenaProviderId: "188",
    credential: "PA-C",
    departmentId: null,
    athenaStaffBucket: null,
  },
  // No staff bucket provided yet.
  PECK: {
    name: "Victoria Peck, PA-C",
    athenaProviderId: "169",
    credential: "PA-C",
    departmentId: null,
    athenaStaffBucket: null,
  },
  HERR: {
    name: "Holly Petrusson Herr, PA-C",
    athenaProviderId: "167",
    credential: "PA-C",
    departmentId: null,
    athenaStaffBucket: "hherr STAFF",
  },
} as const satisfies Record<string, CvvcProviderRosterEntry>;

const CVVC_STAFF_BUCKET_BY_PROVIDER_ID: Readonly<Record<string, string | null>> = Object.fromEntries(
  Object.values(CVVC_PROVIDERS).map((provider) => [provider.athenaProviderId, provider.athenaStaffBucket])
);

export function getCvvcProviderStaffBucket(providerEhrId: string | null): string | null {
  if (!providerEhrId) return null;

  return CVVC_STAFF_BUCKET_BY_PROVIDER_ID[providerEhrId] ?? null;
}
